import { useQuery } from '@tanstack/react-query';

import { getAdminOverview } from '@/api/admin';

export function useAdminOverview() {
  return useQuery({
    queryKey: ['admin', 'overview'],
    queryFn: () => getAdminOverview(),
    refetchInterval: 15_000,
  });
}
